import React, { useState, useEffect } from 'react';

import { FirstDatabaseGAOnboarding } from '@confluence/databases-onboarding-ga';

import type { DatabaseOnboardingService } from './services/database-onboarding-service';

export const DatabaseOnboarding = ({
	onboardingService,
}: {
	onboardingService: DatabaseOnboardingService;
}) => {
	const [onboardingStep, setOnboardingStep] = useState<string>();

	useEffect(() => {
		onboardingService.registerOnOnboardingChangeCallback((step) => {
			setOnboardingStep(step);
		});
	}, [onboardingService]);

	return <FirstDatabaseGAOnboarding currentStep={onboardingStep} setNextStep={setOnboardingStep} />;
};
